import { constantRouterMap } from 'src/router';
import { buildRoutesFromMenus } from 'src/router/componentMap';

/**
 * 递归查找当前路由，用于更新侧边栏高亮
 */
function getNowRouter(routerList, to) {
  return routerList.some(route => {
    if (to.path.indexOf(route.path) !== -1) {
      return true;
    } else if (route.children && route.children.length) {
      return getNowRouter(route.children, to);
    }
  });
}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    siderbar_routers: {},
    isRoutesInitialized: false,
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      state.isRoutesInitialized = true;
    },
    RESET_ROUTES: (state) => {
      state.addRouters = [];
      state.routers = constantRouterMap;
      state.siderbar_routers = {};
      state.isRoutesInitialized = false;
    },
    SET_NOW_ROUTERS: (state, to) => {
      // 在 addRouters[0].children（顶级菜单列表）里找匹配当前路径的父菜单
      const mainRoute = state.addRouters[0];
      if (!mainRoute || !mainRoute.children) return;
      mainRoute.children.forEach(topMenu => {
        if (!topMenu.children) return;
        if (getNowRouter(topMenu.children, to)) {
          state.siderbar_routers = topMenu;
        }
      });
    }
  },
  actions: {
    // menus 为菜单平铺数组（来自 /sysapi/menu/mymenus 接口）
    GenerateRoutes({ commit, state }, { menus }) {
      return new Promise(resolve => {
        if (state.isRoutesInitialized) {
          resolve();
          return;
        }
        const accessedRouters = buildRoutesFromMenus(menus);
        commit('SET_ROUTERS', accessedRouters);
        resolve();
      });
    },
    ResetRoutes({ commit }) {
      commit('RESET_ROUTES');
    },
    getNowRoutes({ commit }, data) {
      return new Promise(resolve => {
        commit('SET_NOW_ROUTERS', data);
        resolve();
      });
    },
  },
};

export default permission;
